/**
 * Created by alvinoktavianus on 9/15/17
 */

import React, { Component } from 'react'
import Select from 'react-select'
import { orderBy } from 'lodash'
import styles from './SearchItemOrCategory.css'

class SearchItemOrCategory extends Component {
  render () {
    let {input, options, placeholder, onChangeItem, disabled, meta} = this.props
    let {touched, error} = meta
    let optionsData = options.map(val => {
      return {value: val, label: val}
    })

    return <div>
      <Select
        {...input}
        options={orderBy(optionsData, [val => val.value.toLowerCase()], ['asc'])}
        placeholder={placeholder}
        clearable={false}
        onChange={onChangeItem}
        onBlur={(e) => {
          e.preventDefault()
        }}
        disabled={disabled}
        className={touched ? error ? styles.error : styles.success : ''}
      />
    </div>
  }
}

SearchItemOrCategory.propTypes = {
  onChangeItem: React.PropTypes.func,
  placeholder: React.PropTypes.string,
  options: React.PropTypes.array
}

export default (SearchItemOrCategory)



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/SearchItemOrCategory/SearchItemOrCategory.js